import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Preview image of an island's environment (its biome), cropped to the card's 379:258 frame
 * so every island card shows its world at the same size. Set a width to scale it.
 */
@Component({
  selector: 'esn-island-thumb',
  template: '<img class="esn-island-thumb" [src]="imageUrl()" [alt]="alt()" loading="lazy" decoding="async" />',
  styles: [
    ':host { display: block; width: 379px; aspect-ratio: 379 / 258; overflow: hidden; }',
    '.esn-island-thumb { display: block; width: 100%; height: 100%; object-fit: cover; pointer-events: none; }',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IslandThumbComponent {
  readonly imageUrl = input.required<string>();

  /**
   * Text alternative; leave empty when the island's name is shown next to the thumbnail.
   */
  readonly alt = input('');
}
